import { useEffect } from "react";

import { BootLoader } from "./BootLoader";

const SIGN_IN_FALLBACK = "/web/login";

/** Sends a visitor with no session straight to sign-in, back to the page they asked for. */
export function KeycloakHandover({ loginUrl }: { loginUrl: string | null }) {
    useEffect(() => {
        const back = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        const target = new URL(loginUrl || SIGN_IN_FALLBACK, window.location.origin);
        if (back !== "/") {
            target.searchParams.set("redirect", back);
        }
        window.location.replace(target.toString());
    }, [loginUrl]);

    // the waiting page says it without a line of text
    return <BootLoader />;
}
